import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

// ✅ NEW: Get paginated products with filters and sorting
export const getProductsPaginated = async ({
  pageNumber = 1,
  pageSize = 20,
  searchTerm = null,
  categoryId = null,
  brandId = null,
  supplierId = null,
  stockStatus = null,
  sortBy = 'Name',
  sortDirection = 'Asc'
} = {}) => {
  const params = {
    pageNumber,
    pageSize,
    sortBy,
    sortDirection
  };

  // Only add optional params if they have values
  if (searchTerm) params.searchTerm = searchTerm;
  if (categoryId) params.categoryId = categoryId;
  if (brandId) params.brandId = brandId;
  if (supplierId) params.supplierId = supplierId;
  if (stockStatus) params.stockStatus = stockStatus;

  const response = await axiosInstance.get('Product/paginated', { params });
  return response.data;
};

// ✅ Keep old method for backward compatibility
export const getProducts = async () => {
  const response = await axiosInstance.get('Product/get-products');
  return response.data;
};

export const getProductById = async (id) => {
  const response = await axiosInstance.get(`Product/get-product/${id}`);
  return response.data;
};

export const addProduct = async (product) => {
  const res = await axiosInstance.post('product/add-product', product);
  return res.data;
};

export const updateProduct = async (product) => {
  const response = await axiosInstance.post('product/update-product', product);
  return response.data;
};

export const deleteProduct = async (id) => {
  await axiosInstance.delete(`Product/delete-product/${id}`);
};

export const searchProducts = async (paramsObj) => {
  const response = await axiosInstance.get('product/search', { params: paramsObj });
  return response.data;
};

export const downloadTemplate = async () => {
  const response = await axiosInstance.get('Product/import/template', {
    responseType: 'blob'
  });
  return response.data;
};

export const exportProducts = async (includeInventory = false) => {
  const response = await axiosInstance.get('Product/export', {
    params: { includeInventory },
    responseType: 'blob'
  });
  return response.data;
};

export const validateImportFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await axiosInstance.post('Product/import/validate', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 300000 // ✅ 5 minutes timeout for validation
  });
  return response.data;
};

export const importProducts = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await axiosInstance.post('Product/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 300000 // ✅ 5 minutes (300000 milliseconds) timeout for import
  });
  return response.data;
};

// ✅ NEW: Get all categories with products (first page of products for each category)
export const getCategoriesWithProducts = async (pageSize = 10) => {
  const response = await axiosInstance.get('Product/categories-with-products', {
    params: { pageSize }
  });
  return response.data;
};

// ✅ NEW: Get paginated products for a specific category
export const getCategoryProductsPaginated = async (categoryId, pageNumber = 1, pageSize = 10) => {
  const response = await axiosInstance.get(`Product/category/${categoryId}/products`, {
    params: { pageNumber, pageSize }
  });
  return response.data;
};

// ✅ NEW: Get products filtered by category and/or supplier
export const getProductsByFilters = async (categoryId = null, supplierId = null, brandId = null) => {
  const params = new URLSearchParams();
  if (categoryId) params.append('categoryId', categoryId);
  if (supplierId) params.append('supplierId', supplierId);
  if (brandId) params.append('brandId', brandId);
  
  const response = await axiosInstance.get(`Product/filter?${params.toString()}`);
  return response.data;
};

// ✅ Get purchase history for a product
export const getProductPurchaseHistory = async (productId) => {
  const response = await axiosInstance.get(`Product/${productId}/purchase-history`);
  return response.data;
};